import { Injectable } from '@angular/core';
import { Category, ICategoryDataV3 } from '@df/catalog/category/category';
import { KlevuTrackService } from '@df/module-klevu-search/klevu-track.service';

@Injectable({
    providedIn: 'root'
})
export class KlevuTrackServiceDecorator extends KlevuTrackService {
    /**
     * Retrieves category path for sort order request
     */
    override getCategoryPath(category: Category<ICategoryDataV3>): string {
        if (category.data?.klevu_breadcrumbs) {
            return category.data.klevu_breadcrumbs;
        }

        return super.getCategoryPath(category);
    }
}
